import { Component } from '@angular/core';

@Component({
  selector: 'app-standard-page-actions',
  templateUrl: 'standard-page-actions.component.html',
  standalone: false,
})
export class StandardPageActionsComponent {}
